module.exports = __webpack_public_path__ + "img/homeslide3-min.6bb88e71.jpg";